var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isReady ? _c('div', {
    staticClass: "content"
  }, [_vm._l(_vm.fieldGroups, function (group, group_id) {
    return [_c('field-group', {
      key: group_id,
      attrs: {
        "group-id": group_id,
        "group-type": "fieldset",
        "group-label": group.label,
        "group-config": group
      }
    }, [_vm._l(_vm.getChildFields(group.children), function (childElement) {
      return [_vm.isNotEmpty(_vm.fieldData[childElement.name]) ? _c('div', {
        key: childElement.name,
        staticClass: "field"
      }, [_c('div', {
        staticClass: "field-label field__label"
      }, [_vm._v("\n            " + _vm._s(_vm.displayFields2[childElement.name].label) + "\n          ")]), _vm._v(" "), _vm.vHtmlIsSet(_vm.displayFields2[childElement.name], _vm.fieldData) ? _c('div', {
        staticClass: "field-item field__item",
        domProps: {
          "innerHTML": _vm._s(_vm.displayFields2[childElement.name].formatter(_vm.fieldData[childElement.name]).v_html)
        }
      }) : _vm.displayFields2[childElement.name].type === 'link' ? _c('div', {
        staticClass: "field-item field__item"
      }, [_vm.fieldData[childElement.name].url ? _c('b-link', {
        attrs: {
          "href": _vm.fieldData[childElement.name].url
        }
      }, [_vm._v("\n              " + _vm._s(_vm.displayFields2[childElement.name].formatter(_vm.fieldData[childElement.name].text)) + "\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.displayFields2[childElement.name].formatter(_vm.fieldData[childElement.name].text)))])], 1) : _vm.displayFields2[childElement.name].type === 'file_listing' ? _c('div', [_c('file-attachment-listing', {
        key: childElement.name + '-file-listing',
        attrs: {
          "files": _vm.fieldData[childElement.name],
          "allow-file-download": "",
          "allow-file-remove": ""
        }
      })], 1) : _c('div', {
        staticClass: "field-item field__item"
      }, [_vm._v("\n            " + _vm._s(_vm.displayFields2[childElement.name].formatter(_vm.fieldData[childElement.name])) + "\n          ")])]) : childElement.name === 'field_inc_invest_recommendations' ? _c('div', {
        key: childElement.name
      }, [_c('corrective-actions-listing', {
        key: "field_inc_invest_recommendations",
        attrs: {
          "investigation-uuid": _vm.uuid,
          "disabled": false
        }
      })], 1) : _vm._e()];
    })], 2)];
  })], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }